module.exports = __webpack_public_path__ + "static/media/yyzz.16f599a3.png";